var map = {
	"./decidim/avatar-multiuser.png": 40358,
	"./decidim/brands/google.svg": 28681,
	"./decidim/cc-badge.png": 86488,
	"./decidim/decidim-logo.svg": 37796,
	"./decidim/default-avatar.svg": 62716,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 70696,
	"./decidim/icons.svg": 93367,
	"./decidim/pattern.png": 60792,
	"./decidim/placeholder-card-g.svg": 75005,
	"./decidim/placeholder-card-l.svg": 23318,
	"./decidim/placeholder.jpg": 79253,
	"./decidim/remixicon.symbol.svg": 49433,
	"./decidim/vendor/leaflet/layers-2x.png": 9176,
	"./decidim/vendor/leaflet/layers.png": 41127,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 19506,
	"./decidim/vendor/leaflet/marker-icon.png": 62649,
	"./decidim/vendor/leaflet/marker-shadow.png": 21814,
	"./decidim/vendor/social-share-button/douban.svg": 30296,
	"./decidim/vendor/social-share-button/email.svg": 213,
	"./decidim/vendor/social-share-button/facebook.svg": 74379,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 98373,
	"./decidim/vendor/social-share-button/hacker_news.svg": 95717,
	"./decidim/vendor/social-share-button/linkedin.svg": 58221,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 75006,
	"./decidim/vendor/social-share-button/pinterest.svg": 58635,
	"./decidim/vendor/social-share-button/reddit.svg": 57503,
	"./decidim/vendor/social-share-button/telegram.svg": 15506,
	"./decidim/vendor/social-share-button/tumblr.svg": 71121,
	"./decidim/vendor/social-share-button/twitter.svg": 4772,
	"./decidim/vendor/social-share-button/vkontakte.svg": 33658,
	"./decidim/vendor/social-share-button/wechat.svg": 30981,
	"./decidim/vendor/social-share-button/whatsapp.svg": 84981,
	"./decidim/vendor/social-share-button/x.svg": 74357,
	"./decidim/vendor/social-share-button/xing.svg": 72427
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68577;